import { Injectable } from '@angular/core';
import { BaseService } from '../../../shared/services/base.service';
import { ConsultationType, ConsultationValue } from '../../../models/consultation/consultation.model';
import { CentreUrl } from '../../../shared/urls/centre.url';
import { InvoiceUrl } from '../../../shared/urls/invoice.url';
import { Utility } from '../../../common/utility';
import { ConsultationUrl } from '../../../shared/urls/consultation.url';

@Injectable()
export class ConsultationStatusService {
    constructor(public baseService: BaseService) {
    }

    newConsultation(patientId, consultationId) {
        const url = Utility.stringFormat(CentreUrl.NEW_CONSULTATION, [patientId, consultationId]);
        return this.baseService.postData(url, null);
    }

    createConsultationInvoice(consultationId) {
        const url = Utility.stringFormat(InvoiceUrl.CONSULTATION_INVOICE, [consultationId]);
        return this.baseService.postData(url, null);
    }
    moveToConfirmLabtest(consultationId){
        const url = Utility.stringFormat(ConsultationUrl.MOVE_TO_CONFIRM_LABTEST, [consultationId]);
        return this.baseService.put(url, null);
    }
}



// WEBPACK FOOTER //
// D:/TMB/sr-git-v1/TMB.UI/src/app/pages/consultation/consultation-status/consultation-status.service.ts